/**
 * FormGroup — Wrapper para campos de formulário
 */
import { T } from '../../styles/tokens';

interface FormGroupProps {
  label: string;
  required?: boolean;
  helper?: string;
  children: any;
}

export function FormGroup({ label, required, helper, children }: FormGroupProps) {
  return (
    <div style={{ marginBottom: T.space4 }}>
      <label style={{ display: 'block', fontSize: T.textSm, fontWeight: T.weightSemibold, color: T.textSecondary, marginBottom: 6 }}>
        {label}{required && <span style={{ color: T.danger, marginLeft: 2 }}>*</span>}
      </label>
      {children}
      {helper && <div style={{ fontSize: T.textXs, color: T.textMuted, marginTop: T.space1 }}>{helper}</div>}
    </div>
  );
}
